import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const Icons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(4),
}));

export const Icon = styled('div')(() => ({
  display: 'inline-block',
  width: 35,
  height: 35,
  overflow: 'hidden',
}));
